import RightPane from './RightPane'

import './style.scss'

export { RightPane }
export default RightPane
